<template>
  <v-dialog v-model="show" width="750">
    <v-card>
      <v-card-title primary-title> Users </v-card-title>

      <v-card-text>
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">Bookmarked by</th>
              <th class="text-left">Bookmarked on</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users.data" :key="user.id">
              <td>
                {{ `${user.user.first_name} ${user.user.last_name}` }}
              </td>
              <td>{{ user.createdAt }}</td>
            </tr>
          </tbody>
        </v-simple-table>
        <div v-if="users.meta.last_page > 1" class="text-center mt-4">
          <v-pagination
            @input="pageChanged"
            :value="users.meta.current_page"
            :length="users.meta.last_page"
            :total-visible="10"
            circle
          />
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="show = false"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Resource from '@/models/Resource'
import BookmarkUser from '@/models/BookmarkUser'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    resource: {
      type: Resource
    }
  },

  data() {
    return {
      show: this.value,
      users: {
        data: [],
        meta: {
          current_page: 1
        }
      },
      userBookmarks: {
        data: [],
        meta: {
          current_page: 1
        }
      }
    }
  },

  methods: {
    pageChanged(page) {
      this.userBookmarks.meta.current_page = page
      this.getReports()
    },

    getUsers() {
      if (this.resource) {
        return BookmarkUser.where('bookmark_id', this.resource.id)
          .include('user')
          .limit(10)
          .page(this.userBookmarks.meta.current_page)
          .get()
          .then(response => {
            this.users = response
          })
          .catch(() => (this.show = false))
          .then(() => {
            this.loading = false
          })
      }
    }
  },
  watch: {
    value(val) {
      this.show = val
    },

    resource(resource) {
      this.users.meta.current_page = 1
      this.getUsers()
    },

    show(val) {
      this.$emit('input', val)
    }
  }
}
</script>
